import { MainHero } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './HeroBlock.module.scss'

const HeroBlock = ({ banner: { title, description, textColor, textBackground, image } }) => (
  <div className={styles.HeroBlock} style={{ backgroundColor: textBackground || '#14aea5' }}>
    <MainHero
      title={title ? `<span style="color: ${textColor}">${title}</span>` : ''}
      titleType="banner"
      subtitle={description ? `<span style="color: ${textColor}">${description}</span>` : ''}
      background={textBackground || '#14aea5'}
      image={image || ''}
      imagePosition="right"
      imageSize="auto"
    />
  </div>
)

HeroBlock.propTypes = {
  banner: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    textColor: PropTypes.string,
    textBackground: PropTypes.string,
    image: PropTypes.string
  })
}

HeroBlock.defaultProps = {
  banner: {
    title: '',
    description: '',
    textColor: '',
    textBackground: '',
    image: ''
  }
}

export default HeroBlock
